/*
* @Author: tengmaoqing
* @Date:   2018-06-12 09:51:39
* @Last Modified by:   tengmaoqing
* @Last Modified time: 2018-06-12 20:45:14
*/
import Model from '@/core/models/model';
import { getProducts } from '@/apis/base';

// const HOTBRAND = '-1';
// const DEFAULT_CATE = '1';
const DEFAULT_PAGE_SIZE = 20;

export default {
  components: {
    Model
  },
  asyncData ({ store, route }, pageSize = 20) {
    const cid = route.params.categoryId;
    const bid = route.params.brandId;
    const pageIndex = route.params.pageIndex;
    return store.dispatch('models/fetchPageData', {
      classid: cid,
      brandid: bid,
      pageIndex,
      pageSize
    });
  },
  data () {
    return {
      moreProducts: [],
      productPageSize: DEFAULT_PAGE_SIZE
    };
  },
  computed: {
    products () {
      return this.$store.state.models.product.list.concat(this.moreProducts);
    },
    brands () {
      return this.$store.state.models.brand.list;
    },
    categories () {
      return this.$store.state.models.category.list;
    },
    pageloading () {
      return this.$store.state.models.product.loading;
    },
    pageInfo () {
      return this.$store.state.models.product.pageInfo;
    },
    currentBrandId () {
      return this.$store.state.models.currentBrandId;
    },
    currentClassId () {
      return this.$store.state.models.currentClassId;
    }
  },
  methods: {
    handleCurrentChange (pageIndex) {
      const categoryId = this.currentClassId;
      const brandId = this.currentBrandId;
      const params = {
        brandId,
        categoryId,
        pageIndex: pageIndex.toString()
      };
      this.$router.replace({
        params
      });
    },
    async handeCategory (categoryId) {
      this.moreProducts = [];
      this.$router.replace({
        name: 'Products',
        params: {
          categoryId: categoryId
        },
        query: this.$route.query
      });
    },
    async handleBrand (brandId) {
      this.moreProducts = [];
      const categoryId = this.currentClassId;
      const params = {
        brandId,
        categoryId
      };
      this.$router.replace({
        name: 'Products',
        params,
        query: this.$route.query
      });
    },
    infiniteHandler ($sta) {
      const currentPage = +this.pageInfo.pageIndex;
      if (currentPage >= this.pageInfo.totalPage) {
        $sta.complete();
        return;
      }

      const nextPage = currentPage + 1;
      const oldUrl = window.location.href;
      getProducts(this.currentClassId, this.currentBrandId, nextPage, this.productPageSize)
        .then(res => {
          const list = res._data.productList;
          // 请求前后的url发生过变化说明切换过类目品牌，则不需要处理回来较慢的数据
          if (oldUrl !== window.location.href) {
            return;
          }
          this.moreProducts = this.moreProducts.concat(list);
          this.$store.commit('models/setPageInfo', res._data.pageInfo);
          $sta.loaded();
        })
        .catch(() => {
          $sta.loaded();
        });
    },
    productTap (data) {
      if (!data.productId) return;
      this.$router.push({
        name: 'ProductInfo',
        params: {
          productId: data.productId
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/core/models/superModel.js